/**
 * Programmatic navigation that works outside of a React Router context.
 * Needed in some of our providers that are not wrapped in a router context.
 * Same-origin URLs use history.pushState + a popstate event so the SPA
 * router picks up the change without a full reload. Cross-origin URLs
 * fall back to a hard navigation via window.location.assign.
 */
export function navigateOutsideRouter(to: string) {
  const url = new URL(to, window.location.origin);

  // Cross-origin should always hard navigate.
  if (url.origin !== window.location.origin) {
    window.location.assign(url.toString());
    return;
  }

  // SPA-style navigation without reload.
  const next = `${url.pathname}${url.search}${url.hash}`;
  window.history.pushState({}, "", next);
  window.dispatchEvent(new PopStateEvent("popstate"));
}
